import * as React from 'react';

import classNames from 'classnames';

import { Spinner } from '@components/common';
import { CheckSVG } from '@components/svgs';

import { ToolInvocation } from '../types';

const STATUS_CONFIG = {
  result: {
    icon: <CheckSVG className='h-4 w-4' />,
    text: 'Done',
    className: 'text-green-600'
  },
  'partial-call': {
    icon: null,
    text: 'Tool executing...',
    className: 'text-gray-500 animate-pulse'
  }
} as const;

interface ToolStatusProps {
  state: ToolInvocation['state'];
  doneText?: string;
  executingText?: string;
}

export const ToolStatus: React.FC<ToolStatusProps> = ({ state, doneText, executingText }) => {
  const config = STATUS_CONFIG[state as keyof typeof STATUS_CONFIG];
  if (!config) return null;

  const finalConfig = {
    ...config,
    text: (state === 'result' ? doneText : executingText) || config.text
  };

  return (
    <div className={classNames('my-3 flex items-center gap-2', finalConfig.className)}>
      {finalConfig.icon}
      <span className='text-sm font-medium'>{finalConfig.text}</span>
    </div>
  );
};
